<table class="skeleton-table">
    <tr>
        <td>
            <div class="skeleton-box"></div>
        </td>
        <td>
            <div class="skeleton-box"></div>
        </td>
        <td>
            <div class="skeleton-box"></div>
        </td>
    </tr>
    <tr>
        <td>
            <div class="skeleton-box"></div>
        </td>
        <td>
            <div class="skeleton-box"></div>
        </td>
        <td>
            <div class="skeleton-box"></div>
        </td>
    </tr>
    <tr>
        <td>
            <div class="skeleton-box"></div>
        </td>
        <td>
            <div class="skeleton-box"></div>
        </td>
        <td>
            <div class="skeleton-box"></div>
        </td>
    </tr>
</table>
